import React from "react";
import { node, string } from "prop-types";
import { Col, Container, Row } from "../../../Grid";
import Section from "../../../Section";
import Heading from "../../../Heading";
import Paragraph from "../../../Paragraph";
import { classes } from "../../../utils/classes";

export const AboutUsSection = ({ children, ...props }) => {
	return (
		<Section spacing={{ my: 20 }}>
			<Container>
				<Row utility={{ justify: "center" }}>
					<Col sm={12} md={12} lg={9} {...props}>
						{children}
					</Col>
				</Row>
			</Container>
		</Section>
	);
};

AboutUsSection.propTypes = {
	children: node.isRequired,
	...Col.propTypes,
};

export const AboutUsHeading = ({ children }) => {
	return (
		<Heading Tag="h2" sx={{ fontSize: "xl", fontWeight: "medium", textAlign: "center" }}>
			{children}
		</Heading>
	);
};

AboutUsHeading.propTypes = {
	children: node.isRequired,
};

export const AboutUsParagraph = ({ children, className = "" }) => {
	return <Paragraph className={classes(className)}>{children}</Paragraph>;
};

AboutUsParagraph.propTypes = {
	children: node.isRequired,
	className: string,
};
